module.exports = __webpack_public_path__ + "static/img/m3.c4ab7c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/mobile/m3.png
// module id = onCG
// module chunks = 12